
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import CourseOccupy from '../../components/course/course-occupy.vue'
import loges from '../../components/course/loges.vue'

@Component({
  name: 'package',
  components: { CourseOccupy, loges }
})
export default class extends Vue {
  @Prop() order_info_id: string
  @Prop() is_show_order_info: boolean
  @Prop() option_id: string
  @Prop() is_model: boolean


  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  orderDetails: any = {
    customer_name: '',
    business_name: '',
    sex: '',
    recommend_employee_id: '',
    connect_employee_id: '',
    sale_employee_id: '',
    audition_teacher_employee_id: '',
    campus_id: '',
    teacher_employee_id: '',
    category: '',
    packet_id: '',
    price: '',
    pay_price: '',
    is_owed: '',
    order_type: '',
    other_name: '',
    pay_type: '',
    number: '',
    status: 0,
    status_remark: '',
    recommend_employee_name: '',
    connect_employee_name: '',
    sale_employee_name: '',
    audition_teacher_employee_name: '',
    campus_name: '',
    teacher_employee_name: ''
  }
  orderId: any = ''
  optionId: any = ''
  optionList: any = []
  dialogAddZy: boolean = false
  title: string = ''
  submitType: number = 0

  logesFrom: string = 'edu_order'
  action: boolean = false
  logHeight: number = 750
  p_hight: any = window.innerHeight - 100 + 'px'
  order_status_option: boolean = true


  @Watch('is_show_order_info')
  getId(newVal,oldVal) {
    if(newVal) {
      this.orderId = this.order_info_id
      this.optionId = this.option_id
      this.option()
      this.action = true
      this.getHeight()
    }
  }
  close() {
     this.refreshData()
     this.action = false
     this.$emit('close-order', false)
    
  }
  async onSubmit(type) {
    this.submitType = type
    //  type 1.提交 2.无效 3.退费
    let data = {
      data: {}
    }
    if (type === 1) {
      let data = {
        data: {
          status: this.submitType,
          recommend_employee_id: this.orderDetails.recommend_employee_id,
          connect_employee_id: this.orderDetails.connect_employee_id,
          sale_employee_id: this.orderDetails.sale_employee_id,
          campus_id: this.orderDetails.campus_id,
          audition_teacher_employee_id: this.orderDetails.audition_teacher_employee_id,
          teacher_employee_id: this.orderDetails.teacher_employee_id
        },
        data_id: this.orderId
      }
      this.order(data)
    } else if (type === 2) {
      this.title = '把该订单设为无效吗？'
      this.dialogAddZy = true
    } else if (type === 3) {
      this.title = '确定该订单退费吗？'
      this.dialogAddZy = true
    }
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }
  handleOrder(val) {
    let data = {
      data: {
        status: this.submitType,
        status_remark: val.desc
      },
      data_id: this.orderId
    }
    if (val.type === 'true') {
      this.order(data)
    } else {
      this.dialogAddZy = false
    }
  }

  refreshData() {
    this.orderDetails = {
      customer_name: '',
      business_name: '',
      sex: '',
      recommend_employee_id: '',
      connect_employee_id: '',
      sale_employee_id: '',
      audition_teacher_employee_id: '',
      campus_id: '',
      teacher_employee_id: '',
      category: '',
      packet_id: '',
      price: '',
      pay_price: '',
      is_owed: '',
      order_type: '',
      other_name: '',
      pay_type: '',
      number: '',
      status: 0,
      status_remark: '',
      recommend_employee_name: '',
      connect_employee_name: '',
      sale_employee_name: '',
      audition_teacher_employee_name: '',
      campus_name: '',
      teacher_employee_name: ''
    }
    this.order_status_option = true
  }
  async order(data) {
    const res: any = await CourseModule.modifyOrderDetail(data)
    if (res.code === 200) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      this.refreshData()
      this.action = false
      this.dialogAddZy = false
      this.$emit('close-order', true)
    } else {
      this.$message.error('操作失败')
    }
  }

  async getDetail() {
    const res: any = await CourseModule.getOrderDetail({ order_id: this.orderId })
    if (res.code === 200) {
      const data = res.data[0]
      for (var i in data) {
        if(i === 'status') {
          if(data[i] === 2 || data[i] === 3) {
            this.order_status_option = true
          } else {
            this.order_status_option = false
          }
        }
        for (var j in this.orderDetails) {
          if (i === j) {
            this.orderDetails[j] = data[i]
          }
        }
      }
      this.action = true
    }
  }

  async option() {
    const res: any = await CourseModule.options({ optionId: this.optionId, org_id: this.org_id })
    if (res.code === 200) {
      this.optionList = res.data
      this.getDetail()
    }
  }
  mounted() {
    this.orderId = this.order_info_id
    this.optionId = this.option_id
    this.option()
    this.action = true
    this.getHeight()
  }
}
